import { signal } from '@preact/signals';

/** `tiers → payment → add-another` loops per product; `customer-info` submits. */
export type Step = 'entry' | 'tiers' | 'payment' | 'add-another' | 'customer-info';

export const step = signal<Step>('entry');

/** Which cart entry the payment / add-another steps are about. */
export const activeCartIndex = signal<number | null>(null);

/** Where "back" from the payment step goes — a fresh add drops the entry, an edit doesn't. */
export const paymentOrigin = signal<'tiers' | 'customer-info'>('tiers');

/** Module-level, so a remount would otherwise resume at the previous mount's step. */
export function resetStep(): void {
  step.value = 'entry';
  activeCartIndex.value = null;
  paymentOrigin.value = 'tiers';
}

export function openPaymentFor(index: number, origin: 'tiers' | 'customer-info'): void {
  activeCartIndex.value = index;
  paymentOrigin.value = origin;
  step.value = 'payment';
}
